import {
    EMERGENCY_ACCESS_REQUEST_REQUEST,
    EMERGENCY_ACCESS_REQUEST_SUCCESS,
    EMERGENCY_ACCESS_REQUEST_FAIL,
    EMERGENCY_ACCESS_REQUEST_RESET,
    EMERGENCY_ACCESS_VERIFY_REQUEST,
    EMERGENCY_ACCESS_VERIFY_SUCCESS,
    EMERGENCY_ACCESS_VERIFY_FAIL,
    EMERGENCY_ACCESS_PATIENT_REQUEST,
    EMERGENCY_ACCESS_PATIENT_SUCCESS,
    EMERGENCY_ACCESS_PATIENT_FAIL,
    EMERGENCY_ACCESS_HISTORY_REQUEST,
    EMERGENCY_ACCESS_HISTORY_SUCCESS,
    EMERGENCY_ACCESS_HISTORY_FAIL,
    EMERGENCY_ACCESS_REVOKE_REQUEST,
    EMERGENCY_ACCESS_REVOKE_SUCCESS,
    EMERGENCY_ACCESS_REVOKE_FAIL
} from '../constants/emergencyAccessConstants';

export const emergencyAccessRequestReducer = (state = {}, action) => {
    switch (action.type) {
        case EMERGENCY_ACCESS_REQUEST_REQUEST:
            return { loading: true };
        case EMERGENCY_ACCESS_REQUEST_SUCCESS:
            return { loading: false, success: true, tokenData: action.payload };
        case EMERGENCY_ACCESS_REQUEST_FAIL:
            return { loading: false, error: action.payload };
        case EMERGENCY_ACCESS_REQUEST_RESET:
            return {};
        default:
            return state;
    }
};

export const emergencyAccessVerifyReducer = (state = {}, action) => {
    switch (action.type) {
        case EMERGENCY_ACCESS_VERIFY_REQUEST:
            return { loading: true };
        case EMERGENCY_ACCESS_VERIFY_SUCCESS:
            return { loading: false, isValid: true, tokenInfo: action.payload };
        case EMERGENCY_ACCESS_VERIFY_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const emergencyAccessPatientReducer = (state = { patient: {} }, action) => {
    switch (action.type) {
        case EMERGENCY_ACCESS_PATIENT_REQUEST:
            return { loading: true };
        case EMERGENCY_ACCESS_PATIENT_SUCCESS:
            return { loading: false, patient: action.payload };
        case EMERGENCY_ACCESS_PATIENT_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const emergencyAccessHistoryReducer = (state = { tokens: [], currentPage: 1, totalPages: 1, totalCount: 0 }, action) => {
    switch (action.type) {
        case EMERGENCY_ACCESS_HISTORY_REQUEST:
            return { ...state, loading: true };
        case EMERGENCY_ACCESS_HISTORY_SUCCESS:
            return {
                loading: false,
                tokens: action.payload.tokens ?? action.payload,
                currentPage: action.payload.currentPage ?? 1,
                totalPages: action.payload.totalPages ?? 1,
                totalCount: action.payload.totalCount ?? (action.payload.tokens ?? action.payload).length,
            };
        case EMERGENCY_ACCESS_HISTORY_FAIL:
            return { loading: false, error: action.payload };
        case EMERGENCY_ACCESS_REVOKE_SUCCESS:
            return {
                ...state,
                tokens: state.tokens.map(token =>
                    token.id === action.payload ? { ...token, isRevoked: true } : token
                )
            };
        default:
            return state;
    }
};

export const emergencyAccessRevokeReducer = (state = {}, action) => {
    switch (action.type) {
        case EMERGENCY_ACCESS_REVOKE_REQUEST:
            return { loading: true };
        case EMERGENCY_ACCESS_REVOKE_SUCCESS:
            return { loading: false, success: true };
        case EMERGENCY_ACCESS_REVOKE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};



